/**
 * Stato di una installazione, calcolato in base allo stato delle singole macchine
 */
export enum ConnectivityStatusEnum {
    Unknown = -1,
    Ok = 0,
    ApplicationOffline = 1,
    AgentOffline = 2,
    Offline = 3,
}

export function connectivityStatusEnumLabel(status: ConnectivityStatusEnum): string {
    switch (status) {
        case ConnectivityStatusEnum.Ok:
            return "enum.connectivity_status.ok";
        case ConnectivityStatusEnum.ApplicationOffline:
            return "enum.connectivity_status.application_offline";
        case ConnectivityStatusEnum.AgentOffline:
            return "enum.connectivity_status.agent_offline";
        case ConnectivityStatusEnum.Offline:
            return "enum.connectivity_status.offline";
        default:
            return "common.unknown";
    }
}

export function connectivityStatusDescription(status: ConnectivityStatusEnum): string {
    switch (status) {
        case ConnectivityStatusEnum.Ok:
            return "enum.connectivity_status.okDescription";
        case ConnectivityStatusEnum.ApplicationOffline:
            return "enum.connectivity_status.application_offlineDescription";
        case ConnectivityStatusEnum.AgentOffline:
            return "enum.connectivity_status.agent_offlineDescription";
        case ConnectivityStatusEnum.Offline:
            return "enum.connectivity_status.offlineDescription";
        default:
            return "common.unknownDescription";
    }
}
